import { Callout, Typography } from 'seagull';
import { getCumulativeWarning } from "../BillServiceTableItem/BillServiceTableItem.utils";
import { serviceCostModel } from "../../../models";
import { utils } from "../../../utils";
import pluralize from "../../../utils/pluralize";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function CumulativeWarningCallout(props) {
  const {
    service,
    issueDate,
    manualServiceBilling,
    testId
  } = props;
  const cumulativeWarning = getCumulativeWarning(service, issueDate, manualServiceBilling);
  function getQuantityText(q) {
    return "".concat(utils.formatNumberWithCommas(q), " ").concat(pluralize(serviceCostModel.formattedUnitName(service.cost), q.toNumber()));
  }
  return cumulativeWarning ? /*#__PURE__*/_jsx(Callout, {
    style: {
      flex: '1'
    },
    intent: cumulativeWarning.isWarning ? 'warning' : 'info',
    testId: "".concat(testId, "-warning"),
    withBorder: true,
    children: serviceCostModel.isVariablePrice(service.cost) ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/_jsxs(Typography, {
        testId: "".concat(testId, "-billed-quantity"),
        "data-quantity": cumulativeWarning.billedQuantity,
        children: ["This service was billed for ", getQuantityText(cumulativeWarning.billedQuantity), " this period."]
      }), cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/_jsxs(Typography, {
        testId: "".concat(testId, "-scheduled-quantity"),
        "data-quantity": cumulativeWarning.scheduledQuantity,
        children: ["This service is scheduled to be billed for", ' ', getQuantityText(cumulativeWarning.scheduledQuantity), " this period."]
      }), /*#__PURE__*/_jsx(Typography, {
        children: "Client approval is required if the preapproved quantity is exceeded."
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/_jsx(Typography, {
        testId: "".concat(testId, "-billed-fixed"),
        children: "This service has already been billed for the period."
      }), cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/_jsx(Typography, {
        testId: "".concat(testId, "-scheduled-fixed"),
        children: "This service is scheduled to be billed for the period."
      }), /*#__PURE__*/_jsx(Typography, {
        children: "An additional bill will require client's approval."
      })]
    })
  }) : null;
}